import { CourseTerm } from '@graphql/generated-graphql';
import { Menu } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { MenuContainer, MenuItemContainer, MenuFieldItem } from '@skipper/ui';
import { Button } from '@skipper/ui';
import React from 'react';

export function CourseTermsListDropdown({
    courseTerm,
    termsList,
    setSelectedTerm,
    variant = 'textOnlyDark',
    size = 'small',
    showAllTermsText = 'Show All',
    onTermChange,
}: {
    courseTerm?: CourseTerm | null;
    termsList?: CourseTerm[] | null;
    setSelectedTerm: (term: CourseTerm | undefined) => void;
    variant?: 'textOnlyDark' | 'white' | 'textOnly';
    size?: 'small' | 'medium';
    showAllTermsText?: string;
    onTermChange?: (term: CourseTerm | undefined) => void;
}) {
    const hideDropdownOptions =
        !termsList || (termsList.length <= 1 && termsList[0]?.id === courseTerm?.id);
    return (
        <Menu as={MenuContainer}>
            {({ open }) => {
                return (
                    <React.Fragment>
                        <Menu.Button
                            as={Button}
                            size={size}
                            type="button"
                            variant={variant}
                            open={open}
                            css={{
                                ['&:disabled']: {
                                    backgroundColor: 'white',
                                    ['&:hover']: {
                                        backgroundColor: 'white',
                                    },
                                },
                            }}
                            disabled={hideDropdownOptions}>
                            <div className="flex gap-x-2 items-center">
                                <p className="truncate">{courseTerm?.title ?? showAllTermsText}</p>
                                {!hideDropdownOptions && <ChevronDownIcon className="w-4 h-4" />}
                            </div>
                        </Menu.Button>

                        <Menu.Items as={MenuItemContainer} size="small">
                            {termsList?.map((t) => {
                                return (
                                    <Menu.Item key={t.id}>
                                        {({ active }) => {
                                            return (
                                                <MenuFieldItem
                                                    key={t.id}
                                                    active={active}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (e?.cancelable) {
                                                            e?.stopPropagation();
                                                        }
                                                        setSelectedTerm(t);
                                                        onTermChange?.(t);
                                                    }}>
                                                    {t?.title}
                                                </MenuFieldItem>
                                            );
                                        }}
                                    </Menu.Item>
                                );
                            })}
                            {termsList?.length > 1 && (
                                <Menu.Item>
                                    {({ active }) => {
                                        return (
                                            <MenuFieldItem
                                                key={'show_all'}
                                                active={active}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (e?.cancelable) {
                                                        e?.stopPropagation();
                                                    }
                                                    setSelectedTerm(undefined);
                                                    onTermChange?.(undefined);
                                                }}>
                                                Show All
                                            </MenuFieldItem>
                                        );
                                    }}
                                </Menu.Item>
                            )}
                        </Menu.Items>
                    </React.Fragment>
                );
            }}
        </Menu>
    );
}
